// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5610) return "static/chunks/5610-build-1752734157046-86996bde807fcb70.js";
	if (chunkId === 2626) return "static/chunks/2626-build-1752734157046-3c0675092693b37b.js";
	if (chunkId === 8030) return "static/chunks/8030-build-1752734157046-ff52f6a06c82a940.js";
	if (chunkId === 5571) return "static/chunks/5571-build-1752734157046-d0ba0078f48871e9.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-build-1752734157046." + {"354":"93dee396257ce5fc","3296":"a8791084adcdf1e3","6483":"1612766366ceb68b","8096":"f79eb185486d4b8f","8241":"b6920ba190e8e17f","8505":"8c5855c7eae9ef7f","8847":"2f4fd08530c41d6f","9443":"db938afaa7dcefe3"}[chunkId] + ".js";
};